import React, { useEffect, useRef, useState } from "react";
import { Outlet, Navigate, Link, useOutletContext } from "react-router-dom";
import useToken from "../components/helpers/useToken";
import MainNavItem from "../components/shared/MainNavItem";
import apiClient from "../components/utils/apiClient";
import useUser from "../components/helpers/useUser";
import { useTranslation } from "react-i18next";
import LangSwithcher from "../components/helpers/LangSwithcher";

const AppLayout = ({ children }) => {
  const {t, i18n} = useTranslation();
  const [token, setToken] = useToken();
  const [navState, setNavState] = useState(true);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [user,setUser] = useUser();


  if(!user) {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('b-user');
    window.location.href = `/${i18n?.language || 'ar'}/login`;
  }

  return (
    token ? 
    <div className="app-layout flex overflow-y-hidden h-screen w-screen">
      {/* Desktop nav toggle arrow - hidden on mobile */}
      <div className={`hidden lg:block w-[24px] h-[24px] cursor-pointer absolute top-[25px] z-[30] transition-all ${navState ? 'rotate-0 ltr:rotate-180 start-[217px]' : 'rotate-180 ltr:rotate-0 start-[99px]'}`} style={{background:"url('/assets/images/arrow-circle-right.svg')"}} onClick={()=>setNavState(!navState)}></div>
      
      {/* Mobile overlay backdrop */}
      {mobileNavOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/50 z-[20]" 
          onClick={() => setMobileNavOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed z-[21] flex flex-col flex-shrink-0 w-[229px] max-h-screen transition-all transform lg:z-auto lg:static ${mobileNavOpen ? 'translate-x-0' : 'translate-x-full ltr:translate-x-[-229px] lg:ltr:translate-x-0'} lg:translate-x-0 ${navState ? 'lg:w-[229px]' : 'lg:w-[111px]'}`}>
        <div className="bg-darkBlue w-full h-screen overflow-y-auto">
          <div className="flex items-center justify-between px-[20px] mt-[35px] lg:block">
            <Link to="/" className={`block bg-center bg-no-repeat ${navState ? 'lg:w-[118px] lg:h-[45px] w-[90px] h-[34px]' : 'w-[50px] h-[42px]'} mx-0 lg:mx-auto`} style={{background: navState ? i18n.language === 'ar' ? "url('/assets/images/logo-white.svg')" : "url('/assets/images/logo-white-en.svg')" : "url('/assets/images/logo-mini-white.svg')", backgroundSize:'contain', backgroundRepeat:'no-repeat'}}></Link>
            {/* Mobile close button */}
            <button 
              className="lg:hidden text-white p-2"
              onClick={() => setMobileNavOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <nav className="pt-[35px]">
            {navState && <span className="text-[16px] font-[400] leading-[34px] text-grey-300 ps-[20px]">{t('nav.menu')}</span>}
            <ul className="p-0 m-0">
              <MainNavItem navStatus={navState} label={t('nav.home')} icon={'main-home-icon.svg'} link={'/'} setMobileNavOpen={setMobileNavOpen} />
              <MainNavItem navStatus={navState} label={t('nav.requests')} icon={'main-request-icon.svg'} link={`/${i18n?.language || 'ar'}/requests`} setMobileNavOpen={setMobileNavOpen} />
              <MainNavItem navStatus={navState} label={t('nav.workers')} icon={'main-user-icon.svg'} link={`/${i18n?.language || 'ar'}/workers`} setMobileNavOpen={setMobileNavOpen} />
              <MainNavItem navStatus={navState} label={t('nav.reports')} normalIcon={true} icon={'nav-note.svg'} link={`/${i18n?.language || 'ar'}/reports`} setMobileNavOpen={setMobileNavOpen} />
              <MainNavItem navStatus={navState} label={t('nav.wallet')} normalIcon={true} icon={'menu-wallet.svg'} link={`/${i18n?.language || 'ar'}/wallet`} setMobileNavOpen={setMobileNavOpen} />
            </ul>
          </nav>
          <LangSwithcher navStatus={navState} />
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 h-full overflow-y-hidden lg:overflow-y-auto min-w-0">
        {/* Mobile top bar */}
        <div className="lg:hidden flex items-center h-[56px] bg-white border-b border-grey-200 px-4 flex-shrink-0">
          <button
            className="text-grey-600 p-1 me-3"
            onClick={() => setMobileNavOpen(true)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <Link to="/">
            <img src="/assets/images/logo-normal.svg" className="h-[32px]" alt="" />
          </Link>
        </div>
        <Outlet context={{navState}}/> 
      </div>
    </div> : <Navigate to={`/${i18n?.language || 'ar'}/login`} />
  );
};

export function useAppLatyoutContext() {
  return useOutletContext();
}

export default AppLayout;
